import React from 'react';
import { GetStaticProps } from 'next';
import {
  ProfessionalsDownloadsDocumentsPage,
  ProfessionalsDownloadsDocumentsPageProps,
  ProfessionalsDownloadsDocumentType,
} from 'src/modules/professionals/downloads/documents';
import { fetchDownloadsDocumentsSSG } from 'src/modules/professionals/downloads/documents';
import { AssetCategoryEnum } from 'src/modules/assets';

const PageProfessionalsDownloadsCare: React.FunctionComponent<ProfessionalsDownloadsDocumentsPageProps> = (
  props
) => {
  return (
    <ProfessionalsDownloadsDocumentsPage
      {...props}
      type={ProfessionalsDownloadsDocumentType.Certificates}
      displayGroupKey={false}
    />
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchDownloadsDocumentsSSG([AssetCategoryEnum.Certificates]);

  return { props: { page: data || null } };
};

export default PageProfessionalsDownloadsCare;
